





















































































































































import { Component, Ref, Watch } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import { ModalFooter } from '@/components/molecules/ModalFooter'
import {
  alertStore,
  authUserStore,
  lendStore,
  modalErrorStore,
  modalQuickMenuStore
} from '@/store'
import { ModalPasswordChange } from '@/components/modals/ModalPasswordChange'
import { ModalBookbinding } from '@/components/modals/ModalBookbinding'
import { ModalBibliographyIntegration } from '@/components/modals/ModalBibliographyIntegration'
import { ModalUsageStatistics } from '@/components/modals/ModalUsageStatistics'
import {
  AUTH_LOGOUT,
  PAGE_LOADING_END,
  PAGE_LOADING_START
} from '@/config/event'
import { AlertMessage, AuthUser, ErrorMessage } from '@/api'
import {
  BatchMenuBibliographyRegisterItem,
  BatchMenuCollectionManagementItem,
  BatchMenuLendReturnReserveItem,
  BatchMenuMailSendItem,
  BatchMenuOrderAcceptItem,
  BatchMenuReminderItem,
  BatchMenuSchoolStatisticsItem,
  BatchMenuStatisticsItem
} from '@/types'

interface Menu {
  key: string
  name: string
  headTitle: string
  groups: MenuGroup[]
}

interface MenuGroup {
  key: string
  groupItems: MenuGroupItem[]
}

interface MenuGroupItem {
  key: string
  title: string
  display: boolean
  onClick: Function
}

const SpecialMenuKey = {
  Batch: 'b',
  ProcessPlace: 's',
  PrintHistory: 'p',
  Logout: 'l'
} as const

@Component({
  components: {
    ModalFooter,
    ModalBookbinding,
    ModalBibliographyIntegration,
    ModalPasswordChange,
    ModalUsageStatistics
  }
})
export default class ModalQuickMenu extends ModalComponentBaseVue {
  @Ref()
  modalBibliographyIntegration!: ModalBibliographyIntegration

  @Ref()
  modalBookbinding!: ModalBookbinding

  @Ref()
  modalPasswordChange!: ModalPasswordChange

  @Ref()
  modalUsageStatistics!: ModalUsageStatistics

  tabMenu: string = 'menu'

  menuFilter: string = ''

  menuSelectedItem: number = -1

  get isOpen(): boolean {
    return modalQuickMenuStore.isOpen
  }

  set isOpen(value: boolean) {
    modalQuickMenuStore.close()
  }

  get authUser(): AuthUser {
    return authUserStore.authUser
  }

  get specialMenus(): Menu[] {
    return [
      {
        key: SpecialMenuKey.Batch,
        name: 'バッチ',
        headTitle: 'バッチ',
        groups: [
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '書誌登録',
                display: authUserStore.authUserBatchMenu.some(
                  batchMenu =>
                    batchMenu.key.startsWith(
                      BatchMenuBibliographyRegisterItem.key
                    ) && batchMenu.value === '1'
                ),
                onClick: this.transitionPage(
                  '/batch-menu/bibliography-register'
                )
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '発注受入',
                display: authUserStore.authUserBatchMenu.some(
                  batchMenu =>
                    batchMenu.key.startsWith(BatchMenuOrderAcceptItem.key) &&
                    batchMenu.value === '1'
                ),
                onClick: this.transitionPage('/batch-menu/order-accept')
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '蔵書管理',
                display: authUserStore.authUserBatchMenu.some(
                  batchMenu =>
                    batchMenu.key.startsWith(
                      BatchMenuCollectionManagementItem.key
                    ) && batchMenu.value === '1'
                ),
                onClick: this.transitionPage(
                  '/batch-menu/collection-management'
                )
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '督促',
                display: authUserStore.authUserBatchMenu.some(
                  batchMenu =>
                    batchMenu.key.startsWith(BatchMenuReminderItem.key) &&
                    batchMenu.value === '1'
                ),
                onClick: this.transitionPage('/batch-menu/reminder')
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '貸出返却予約',
                display: authUserStore.authUserBatchMenu.some(
                  batchMenu =>
                    batchMenu.key.startsWith(
                      BatchMenuLendReturnReserveItem.key
                    ) && batchMenu.value === '1'
                ),
                onClick: this.transitionPage('/batch-menu/lend-return-reserve')
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '統計',
                display: authUserStore.authUserBatchMenu.some(
                  batchMenu =>
                    batchMenu.key.startsWith(BatchMenuStatisticsItem.key) &&
                    batchMenu.value === '1'
                ),
                onClick: this.transitionPage('/batch-menu/statistics')
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: 'メール送信',
                display: authUserStore.authUserBatchMenu.some(
                  batchMenu =>
                    batchMenu.key.startsWith(BatchMenuMailSendItem.key) &&
                    batchMenu.value === '1'
                ),
                onClick: this.transitionPage('/batch-menu/mail-send')
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '学校図書館用',
                display: authUserStore.authUserBatchMenu.some(
                  batchMenu =>
                    batchMenu.key.startsWith(
                      BatchMenuSchoolStatisticsItem.key
                    ) && batchMenu.value === '1'
                ),
                onClick: this.transitionPage('/batch-menu/school-statistics')
              }
            ]
          }
        ]
      },
      {
        key: SpecialMenuKey.ProcessPlace,
        name: '処理場所',
        headTitle: '',
        groups: [
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '処理場所の変更',
                display: true,
                onClick: this.onClickMenuItem(
                  this.$modalProcessPlaceChange.open
                )
              }
            ]
          }
        ]
      },
      {
        key: SpecialMenuKey.PrintHistory,
        name: '印刷履歴',
        headTitle: '',
        groups: [
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '印刷履歴',
                display: true,
                onClick: this.onClickMenuItem(this.$modalReceiptHistory.open)
              }
            ]
          }
        ]
      },
      {
        key: SpecialMenuKey.Logout,
        name: 'ログアウト',
        headTitle: '',
        groups: [
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: 'ログアウト',
                display: true,
                onClick: this.onClickMenuItem(this.logout)
              }
            ]
          }
        ]
      }
    ]
  }

  // コメントアウト箇所は栃木市版では不要
  get menus(): Menu[] {
    return [
      {
        key: '',
        name: 'ナビ',
        headTitle: '',
        groups: [
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: 'トップメニュー',
                display: true,
                onClick: this.transitionPage('/')
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '運用メニュー',
                display: this.authUser.topMenu.operationMenu === 1,
                onClick: this.transitionPage('/operation-management-menu')
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: 'バッチメニュー',
                display: this.authUser.topMenu.batchMenu === 1,
                onClick: this.transitionPage('/batch-menu')
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: 'ジョブ一覧',
                display: this.authUser.topMenu.jobList === 1,
                onClick: this.transitionPage('/jobs')
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '貸出',
                display: this.authUser.group.lending !== 0,
                onClick: this.transitionPage('/lend')
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '返却',
                display: this.authUser.group.return !== 0,
                onClick: this.transitionPage('/return')
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '資料の管理',
                display: this.authUser.group.bibliography !== 0,
                onClick: this.transitionPage('/bibliographies')
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '利用者の管理',
                display: this.authUser.group.user !== 0,
                onClick: this.transitionPage('/user')
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: 'レファレンス',
                display: this.authUser.group.reference !== 0,
                onClick: this.transitionPage('/reference')
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: 'カウント',
                display: this.authUser.topMenu.jobList === 1,
                onClick: this.onClickMenuItem(this.modalUsageStatistics.open)
              }
            ]
          }
        ]
      },
      {
        key: '',
        name: '蔵書',
        headTitle: '蔵書',
        groups: [
          {
            key: '',
            groupItems: [
              {
                key: '0',
                title: '書誌統合',
                display: this.authUser.topMenu.bibliographyIntegration === 1,
                onClick: this.onClickMenuItem(
                  this.modalBibliographyIntegration.open
                )
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '書誌資料情報の一括変更',
                display:
                  this.authUser.topMenu.bibliographyCollectionBulkEdit === 1,
                onClick: this.transitionPage(
                  '/bibliography-collection-bulk-edit'
                )
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '製本処理',
                display: this.authUser.topMenu.bookbinding === 1,
                onClick: this.onClickMenuItem(this.modalBookbinding.open)
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '新配架区分一括変更',
                display: this.authUser.topMenu.shelfTypeTempChange === 1,
                onClick: this.transitionPage('/shelf-type-temp-change')
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '旧配架区分一括変更',
                display: this.authUser.topMenu.shelfTypeTempChange === 1,
                onClick: this.transitionPage('/shelf-type-temp-change-fix')
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '資料リスト',
                display: this.authUser.topMenu.collectionList === 1,
                onClick: this.transitionPage('/collection-list')
              }
            ]
          }
        ]
      },
      {
        key: '',
        name: '発注',
        headTitle: '発注',
        groups: [
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '発注リストの作成',
                display: this.authUser.topMenu.orderListCreate === 1,
                onClick: this.transitionPage('/order-list/create')
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '発注リストの検索',
                display: this.authUser.topMenu.orderListSearch === 1,
                onClick: this.transitionPage('/order-list')
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '簡易発注',
                display: this.authUser.topMenu.simpleOrdering === 1,
                onClick: this.transitionPage('/simple-ordering')
              }
            ]
          }
        ]
      },
      {
        key: '',
        name: '受入',
        headTitle: '受入',
        groups: [
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '資料の受入',
                display: this.authUser.topMenu.acceptCollection === 1,
                onClick: this.transitionPage('/accept-collection')
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '簡易受入',
                display: this.authUser.topMenu.acceptCollectionSimple === 1,
                onClick: this.transitionPage('/accept-collection-simple')
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '資料の本受入',
                display: this.authUser.topMenu.acceptCollectionActual === 1,
                onClick: this.transitionPage('/accept-collection-actual')
              }
            ]
          }
        ]
      },
      {
        key: '',
        name: '予約',
        headTitle: '予約',
        groups: [
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '予約連絡',
                display: this.authUser.topMenu.reservationContact === 1,
                onClick: this.transitionPage('/reservation-contact')
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '予約解除／確認',
                display: this.authUser.topMenu.reservationCancel === 1,
                onClick: this.transitionPage('/reservation-cancel')
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '予約優先割当',
                display: this.authUser.topMenu.reservePreferenceAssign === 1,
                onClick: this.transitionPage('/reserve-preference-assign')
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: 'セット・グループ予約候補リスト',
                display: this.authUser.topMenu.reservationCandidateList === 1,
                onClick: this.transitionPage('/reservation-candidate-list')
              }
            ]
          }
        ]
      },
      {
        key: '',
        name: '館内',
        headTitle: '館内閲覧',
        groups: [
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '館内閲覧',
                display: this.authUser.topMenu.readingInside === 1,
                onClick: this.onClickMenuItem(() => {
                  lendStore.setIsReadingInside(true)
                  this.$router.push('/lend')
                })
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '館内閲覧資料の一覧',
                display:
                  this.authUser.topMenu.readingInsideCollectionList === 1,
                onClick: this.transitionPage('/collection-browse-inside')
              }
            ]
          }
        ]
      },
      {
        key: '',
        name: '回送',
        headTitle: '回送依頼',
        groups: [
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '回送依頼の状況',
                display: this.authUser.topMenu.forwardRequestStatus === 1,
                onClick: this.transitionPage('/forward-request-status')
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '回送依頼の回答',
                display: this.authUser.topMenu.forwardRequestAnswer === 1,
                onClick: this.transitionPage('/forward-request-answer')
              }
            ]
          }
        ]
      },
      {
        key: '',
        name: '相互',
        headTitle: '相互貸借',
        groups: [
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '貸出履歴',
                display:
                  this.authUser.topMenu.interlibraryLoanLendHistory === 1,
                onClick: this.transitionPage('/lend-history')
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '借用履歴',
                display:
                  this.authUser.topMenu.interlibraryLoanBorrowingHistory === 1,
                onClick: this.transitionPage('/borrowing-history')
              }
            ]
          }
        ]
      },
      {
        key: '',
        name: '典拠',
        headTitle: '典拠',
        groups: [
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '典拠の編集',
                display: this.authUser.topMenu.authorityEdit === 1,
                onClick: this.transitionPage('/authority')
              }
            ]
          }
        ]
      },
      {
        key: '',
        name: '運用',
        headTitle: '運用',
        groups: [
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: 'パスワード変更',
                display: this.authUser.topMenu.passwordChange === 1,
                onClick: this.onClickMenuItem(this.modalPasswordChange.open)
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '休館日の設定',
                display: this.authUser.operationMenu.closingDay === 1,
                onClick: this.transitionPage(
                  '/operation-management-menu/closing-day-setting'
                )
              },
              {
                key: '',
                title: '巡回日の設定',
                display: this.authUser.operationMenu.patrolDay === 1,
                onClick: this.transitionPage(
                  '/operation-management-menu/patrol-day-setting'
                )
              },
              {
                key: '',
                title: '返却予定日のスライド',
                display:
                  this.authUser.operationMenu.scheduledReturnDateSlide === 1,
                onClick: this.transitionPage(
                  '/operation-management-menu/scheduled-return-date-slide'
                )
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '資料・利用者チェックの設定',
                display: this.authUser.operationMenu.lendAndUserCheck === 1,
                onClick: this.transitionPage(
                  '/operation-management-menu/setting-document-and-user-check'
                )
              },
              {
                key: '',
                title: '貸出・返却条件の設定',
                display:
                  this.authUser.operationMenu.lendAndReturnConditions === 1,
                onClick: this.transitionPage(
                  '/operation-management-menu/setting-lend-and-return-conditions'
                )
              },
              {
                key: '',
                title: '予約条件の設定',
                display:
                  this.authUser.operationMenu.reservationConditions === 1,
                onClick: this.transitionPage(
                  '/operation-management-menu/setting-reservation-condition'
                )
              }
            ]
          },
          // {
          //   key: '',
          //   groupItems: [
          //     {
          //       key: '',
          //       title: 'セット巻の編集',
          //       display: this.authUser.operationMenu.setVolume === 1,
          //       onClick: this.transitionPage('')
          //     }
          //   ]
          // },
          // {
          //   key: '',
          //   groupItems: [
          //     {
          //       key: '',
          //       title: '予約グループの編集',
          //       display: this.authUser.operationMenu.reservationGroup === 1,
          //       onClick: this.transitionPage('')
          //     }
          //   ]
          // },
          // {
          //   key: '',
          //   groupItems: [
          //     {
          //       key: '',
          //       title: '配架区分の変換情報の設定',
          //       display:
          //         this.authUser.operationMenu.shelfTypeConversionInfo === 1,
          //       onClick: this.transitionPage('')
          //     }
          //   ]
          // }
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '貸出回数の確認',
                display:
                  this.authUser.operationMenu.lendCountConfirmation === 1,
                onClick: this.transitionPage(
                  '/operation-management-menu/lend-books-count-confirmation'
                )
              }
            ]
          },
          // {
          //   key: '',
          //   groupItems: [
          //     {
          //       key: '',
          //       title: '責任表示/出版者/件名/全集/シリーズの削除',
          //       display: this.authUser.operationMenu.authorDelete === 1,
          //       onClick: this.transitionPage('')
          //     }
          //   ]
          // }
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '同義語の設定',
                display: this.authUser.operationMenu.synonymSetting === 1,
                onClick: this.transitionPage(
                  '/operation-management-menu/synonym-setting'
                )
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '分かち辞書の設定',
                display:
                  this.authUser.operationMenu.separateDictionarySetting === 1,
                onClick: this.transitionPage(
                  '/operation-management-menu/separate-dictionary-setting'
                )
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '新着雑誌メールの設定',
                display:
                  this.authUser.operationMenu.newArrivalMagazineMailSetting ===
                  1,
                onClick: this.transitionPage(
                  '/operation-management-menu/new-arrival-magazine-mail-setting'
                )
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: 'コードの設定',
                display: this.authUser.operationMenu.code === 1,
                onClick: this.transitionPage(
                  '/operation-management-menu/code-setting'
                )
              },
              {
                key: '',
                title: 'システムコンフィグの設定',
                display:
                  this.authUser.operationMenu.config === 1 &&
                  authUserStore.isAdministrator,
                onClick: this.transitionPage(
                  '/operation-management-menu/system-config'
                )
              },
              {
                key: '',
                title: 'システムチェック',
                display: this.authUser.operationMenu.systemCheck === 1,
                onClick: this.transitionPage(
                  '/operation-management-menu/system-check'
                )
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '業者・寄贈者の設定',
                display: this.authUser.operationMenu.traderAndDonor === 1,
                onClick: this.transitionPage(
                  '/operation-management-menu/trader-and-donor-setting'
                )
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: 'ログインユーザ管理',
                display: this.authUser.operationMenu.loginUser === 1,
                onClick: this.transitionPage(
                  '/operation-management-menu/login-user-management'
                )
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: 'お知らせの設定',
                display: this.authUser.operationMenu.notice === 1,
                onClick: this.transitionPage(
                  '/operation-management-menu/notification-setting'
                )
              }
            ]
          }
          // {
          //   key: '',
          //   groupItems: [
          //     {
          //       key: '',
          //       title: '予約管理',
          //       display: this.authUser.operationMenu.budgetManagement === 1,
          //       onClick: this.transitionPage('')
          //     }
          //   ]
          // },
          // {
          //   key: '',
          //   groupItems: [
          //     {
          //       key: '',
          //       title: '画像マスタ設定',
          //       display: this.authUser.operationMenu.referenceImage === 1,
          //       onClick: this.transitionPage('')
          //     }
          //   ]
          // }
        ]
      },
      {
        key: '',
        name: '初期値',
        headTitle: '初期値',
        groups: [
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '初期値の変更',
                display: this.authUser.topMenu.defaultValueSetting === 1,
                onClick: this.transitionPage('/setting-default-value')
              }
            ]
          }
        ]
      },
      {
        key: '',
        name: '点検',
        headTitle: '蔵書点検',
        groups: [
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '蔵書点検データの一覧',
                display: this.authUser.topMenu.inspectionList === 1,
                onClick: this.transitionPage('/inspection')
              }
            ]
          },
          {
            key: '',
            groupItems: [
              {
                key: '',
                title: '蔵書点検データ一括更新',
                display: this.authUser.topMenu.inspectionBulkUpdate === 1,
                onClick: this.transitionPage('/inspection-bulk-update')
              }
            ]
          }
        ]
      }
    ]
  }

  get displayMenus(): Menu[] {
    let duplicateMenuKeyCount: number = 0

    const menus = ([...this.menus, ...this.specialMenus] as Menu[])
      .map(menu => ({
        key: menu.key,
        name: menu.name,
        headTitle: menu.headTitle,
        groups: menu.groups
          .map(menuGroup => ({
            key: menuGroup.key,
            groupItems: menuGroup.groupItems.filter(
              menuGroupItem => menuGroupItem.display
            )
          }))
          .filter(menuGroup => menuGroup.groupItems.length > 0)
      }))
      .filter(menu => menu.groups.length > 0)

    menus.forEach((menu: Menu, menuIndex: number) => {
      if (
        !this.specialMenus.map(menu => menu.key).includes(menu.key) &&
        this.specialMenus
          .map(menu => menu.key)
          .includes((menuIndex + duplicateMenuKeyCount).toString(16))
      ) {
        duplicateMenuKeyCount += 1
        menu.key = (menuIndex + duplicateMenuKeyCount).toString(16)
      } else if (!this.specialMenus.map(menu => menu.key).includes(menu.key)) {
        menu.key = (menuIndex + duplicateMenuKeyCount).toString(16)
      }
      menu.groups.forEach((group: MenuGroup, groupIndex: number) => {
        group.key = groupIndex.toString(16)
        group.groupItems.forEach(
          (groupItem: MenuGroupItem, groupItemIndex: number) => {
            groupItem.key = groupItemIndex.toString(16)
          }
        )
      })
    })

    return menus
  }

  get filteredMenus(): Menu[] {
    this.menuSelectedItem = -1
    return this.displayMenus
      .map(menu => ({
        key: menu.key,
        name: menu.name,
        headTitle: menu.headTitle,
        groups: menu.groups
          .map(menuGroup => ({
            key: menuGroup.key,
            groupItems: menuGroup.groupItems.filter(menuGroupItem => {
              if (this.menuFilter === '') {
                return true
              }

              if (this.menuFilter.match(/^[A-Za-z0-9]*$/)) {
                return (
                  (menu.key + menuGroup.key + menuGroupItem.key).indexOf(
                    this.menuFilter
                  ) === 0
                )
              }
              return `${menu.headTitle} ${menuGroupItem.title}`.includes(
                this.menuFilter
              )
            })
          }))
          .filter(menuGroup => menuGroup.groupItems.length > 0)
      }))
      .filter(menu => menu.groups.length > 0)
  }

  get filteredMenuGroupItemCount(): number {
    return this.filteredMenus.reduce((accum: number, current: Menu) => {
      current.groups.forEach(group => (accum += group.groupItems.length))
      return accum
    }, 0)
  }

  get menuKeyDescription(): string {
    return this.displayMenus.reduce(
      (accum: string, menu: Menu, index: number) => {
        if (index !== 0) {
          accum += ' '
        }

        accum += `${menu.key} ${menu.name}`

        if (index === 8) {
          accum += '\n'
        }

        return accum
      },
      ''
    )
  }

  @Watch('isOpen')
  changeOpen(): void {
    this.init()
  }

  init() {
    this.menuFilter = ''
    this.menuSelectedItem = -1
  }

  onClickMenuItem(func: Function): Function {
    return () => {
      // MutationObserverでオーバーレイを監視しているページが有る為、遷移する前に本ダイアログを閉じるように修正
      modalQuickMenuStore.cancel()

      if (func) {
        func()
      }
    }
  }

  transitionPage(path: string): Function {
    return this.onClickMenuItem(() => {
      this.$router.push(path)
    })
  }

  moveNextTab() {
    // if (this.tabMenu === 'menu') {
    //   this.tabMenu = 'collection'
    //   return
    // }
    //
    // if (this.tabMenu === 'collection') {
    //   this.tabMenu = 'user'
    //   return
    // }
    //
    // this.tabMenu = 'menu'
    const elm = document.querySelector<HTMLElement>('.menu-item-input input')
    elm && elm.focus()
    this.menuSelectedItem = -1
  }

  movePrevTab() {
    // if (this.tabMenu === 'menu') {
    //   this.tabMenu = 'user'
    //   return
    // }
    //
    // if (this.tabMenu === 'collection') {
    //   this.tabMenu = 'menu'
    //   return
    // }
    //
    // this.tabMenu = 'collection'
  }

  moveNextMenu() {
    if (this.menuSelectedItem + 1 < this.filteredMenuGroupItemCount) {
      this.menuSelectedItem++
    } else {
      this.menuSelectedItem = 0
    }

    setTimeout(() => {
      const i = this.menuSelectedItem
      const item = document.querySelectorAll<HTMLElement>(
        '.modal-quick-menu .menu-item'
      )[i]
      item.focus()
    }, 0)
  }

  movePrevMenu() {
    if (this.menuSelectedItem - 1 >= 0) {
      this.menuSelectedItem--
      setTimeout(() => {
        const i = this.menuSelectedItem
        const item = document.querySelectorAll<HTMLElement>(
          '.modal-quick-menu .menu-item'
        )[i]
        item.focus()
      }, 0)
      return
    }

    this.menuSelectedItem = -1
    setTimeout(() => {
      const item = document.querySelector<HTMLElement>(
        '.modal-quick-menu .menu-item-input input'
      )
      item && item.focus()
    }, 0)
  }

  async logout() {
    this.$eventBus.emit(PAGE_LOADING_START)
    this.$eventBus.emit(AUTH_LOGOUT)

    try {
      await authUserStore.logout()

      await this.$router.push('/login')
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  enterMenu(): void {
    if (this.filteredMenuGroupItemCount === 1) {
      this.filteredMenus[0].groups[0].groupItems[0].onClick()
    }
  }
}
